import { registerDSCustomElements } from "../src/design_system/shared/utils/customElements";
import { registerCustomElements } from "../src/shared_modules/custom_elements/utils/registerCustomElements";
import { initDSTooltip } from "../src/design_system/primitives/tooltip/utils/initDSTooltip";

registerDSCustomElements();
registerCustomElements();
initDSTooltip();
